import React, { useEffect, useState, useCallback, useRef } from "react";
import CommonLayout from "../../layout/CommonLayout";
import CommonMenu from "../../layout/CommonMenu"; 
import CommonFooter from "../../layout/CommonFooter";
import { useApplicationCommon } from "../../utils/ApplicationCommon"; 
import { Link } from "react-router-dom";

const GNBPURE04003S = () => {
 
  const [isDepthOpen, setIsDepthOpen] = useState(false); // depth2 메뉴 열림 상태

  return (
    <CommonLayout>
      <CommonMenu />

      <div id="contents" className="container">

        <div className="sub-title bg-type01">
          <h2>고객지원</h2>
        </div>

        <div className="location_wrap"
          onClick={() => setIsDepthOpen(!isDepthOpen)}>
          <ul className="depth1">
            <li><Link to="/">home</Link></li>
            <li><Link to="/" onClick={(e) => e.preventDefault()}>Contact Us<span></span></Link>
              <ul className="depth2" style={{ display: isDepthOpen ? "block" : "none" }}>
                <li><Link to="/GNBPURE04001S">제휴문의</Link></li>
                <li><Link to="/GNBPURE04002S">NOTICE</Link></li>
                <li><Link to="/GNBPURE04003S">Contact Us</Link></li>
              </ul>
            </li>
          </ul>
        </div>
        <div id="cont" className="cont">
          <div className="inner">
            <h3>Contact Us</h3>
            <p className="subtitle">담당안내</p>
            <div className="table-type table-row">
            <table>
              <caption>지엔비소프텍 업무별 담당 안내표</caption>
              <colgroup>
                <col style={{ width: "50%" }} />
                <col style={{ width: "auto" }} />
              </colgroup>
              <thead>
                <tr>
                  <th scope="col">업무총괄</th>
                  <th scope="col">영업담당</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <ul className="bul-dot">
                      <li>대표 차호열</li>
                      <li>연락처 : (02)3664-7014</li>
                      <li>핸드폰 : 010-7570-0549</li>
                      <li>이메일 : <a href="mailto:cha@gnbsoftec.co.kr">cha@gnbsoftec.co.kr</a></li>
                    </ul>
                  </td>
                  <td>
                    <ul className="bul-dot">
                      <li>이사 박진성</li>
                      <li>연락처 : (02)3664-7014</li>
                      <li>핸드폰 : 010-5533-9432</li>
                      <li>이메일 : <a href="mailto:jspark@gnbsoftec.co.kr">jspark@gnbsoftec.co.kr</a></li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
            </div>

          </div>
        </div>
      </div>
      <CommonFooter />
    </CommonLayout>
  );
};

export default GNBPURE04003S;